import { EVENT_TYPES } from '../../constants';

export const enableEditMode = () => ({
  type: EVENT_TYPES.EDITMODE_ENABLED,
});

export const disableEditMode = () => ({
  type: EVENT_TYPES.EDITMODE_DISABLED,
});

export const toggleEditMode = () => ({
  type: EVENT_TYPES.EDITMODE_TOGGLE,
});
